import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=0a54c270&scoped=true&"
import script from "./Completion.vue?vue&type=script&lang=ts&"
export * from "./Completion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54c270",
  null
  
)

export default component.exports